import { CommonError } from '../../types';
import { OpenOrderActions } from './actions';
import {
    FETCH_CANCEL_ORDER_FAILURE,
    FETCH_CANCEL_ORDER_REQUEST,
    FETCH_CANCEL_ORDER_SUCCESS,
    FETCH_MATCH_DATA_FAILURE,
    FETCH_MATCH_DATA_REQUEST,
    FETCH_MATCH_DATA_SUCCESS,
    FETCH_OPEN_ORDER_FAILURE,
    FETCH_OPEN_ORDER_REQUEST,
    FETCH_OPEN_ORDER_SUCCESS,
    FETCH_ORDER_FAILURE,
    FETCH_ORDER_REQUEST,
    FETCH_ORDER_SUCCESS,
    FETCH_UPDATE_ORDER_FAILURE,
    FETCH_UPDATE_ORDER_REQUEST,
    FETCH_UPDATE_ORDER_SUCCESS,
} from './constants';
import { MatchData, OpenOrderData } from './types';

export interface StockOrderState {
    openOrderDatas: OpenOrderData[];
    loading: boolean;
    cancelLoading: boolean;
    error: CommonError | null;
    matchLoading: boolean;
    updateLoading: boolean;
    orderLoading: boolean;
    matchDatas: MatchData[];
}
const initialState = {
    loading: false,
    matchLoading: false,
    cancelLoading: false,
    updateLoading: false,
    orderLoading: false,
    openOrderDatas: [],
    matchDatas: [],
    error: null,
};
export const StockOpenOrderReducer = (state = initialState, action: OpenOrderActions): StockOrderState => {
    switch (action.type) {
        case FETCH_OPEN_ORDER_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_OPEN_ORDER_SUCCESS: {
            return { ...state, loading: false, openOrderDatas: action.payload };
        }
        case FETCH_OPEN_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case FETCH_CANCEL_ORDER_REQUEST:
            return { ...state, cancelLoading: true, error: null };
        case FETCH_CANCEL_ORDER_SUCCESS: {
            return { ...state, cancelLoading: false };
        }
        case FETCH_UPDATE_ORDER_REQUEST:
            return { ...state, updateLoading: true, error: null };
        case FETCH_UPDATE_ORDER_SUCCESS: {
            return { ...state, updateLoading: false };
        }
        case FETCH_UPDATE_ORDER_FAILURE:
            return { ...state, updateLoading: false, error: action.payload };

        case FETCH_CANCEL_ORDER_FAILURE:
            return { ...state, cancelLoading: false, error: action.payload };

        case FETCH_ORDER_REQUEST:
            return { ...state, orderLoading: true, error: null };
        case FETCH_ORDER_SUCCESS: {
            return { ...state, orderLoading: false };
        }
        case FETCH_ORDER_FAILURE: {
            return { ...state, orderLoading: false, error: action.payload };
        }

        case FETCH_MATCH_DATA_REQUEST: {
            return { ...state, matchLoading: true };
        }
        case FETCH_MATCH_DATA_SUCCESS:
            return { ...state, matchLoading: false, matchDatas: action.payload };
        case FETCH_MATCH_DATA_FAILURE:
            return { ...state, matchLoading: false, error: action.payload };
        default:
            return state;
    }
};
